import { DIALOGS, OVERLAYS } from '@witmetrics/unison-core';

export const SHORTCUT_KEYS = {
  '\\S': DIALOGS.CASE,
  '\\P': DIALOGS.PATIENT,
  '\\T': DIALOGS.TASK,
  '\\O': DIALOGS.ORDER,
  '\\A': OVERLAYS.AGENDA,
  '\\C': DIALOGS.ACCOUNTS,
} as const;
